export default {
    'this-team': 'this team'
}